<template>
    <div>
        <div class="d-flex justify-content-end fly-competitor-header">
            <b-dropdown
                v-if="selectedPeriodText" 
                size="sm" 
                :text="selectedPeriodText" 
                variant="outline-secondary"
            >
                <b-dropdown-item-button
                    v-for="(button, index) in avaible_periods"
                    @click="changePeriod(index)"
                    :key="index"
                    :variant="button.selected ? 'success':'secondary'"
                >
                    {{ formatDate(button.period_start) }} - {{ formatDate(button.period_finish) }}
                </b-dropdown-item-button>
            </b-dropdown>                    

            <b-button
                @click="updateSuppliesData()"
                size="sm"
                class="ml-2"
                variant="outline-secondary"
                style="width: 30px; height: 28px;"
                :disabled="loading"
            >
                <b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
            </b-button>

            <b-button 
                @click="showHeader = !showHeader" 
                size="sm"
                class="ml-2"
                :variant="showHeader ? 'outline-primary':'outline-secondary'"
                style="height: 28px;"
            >
                Настройки
                <b-icon icon="gear-wide" class="ml-2" scale="1.5" aria-label="Settings"></b-icon>
            </b-button>

            <b-button
                v-if="filteredSuppliesData['items'].length > 0"
                size="sm"
                class="ml-2"
                @click="exportTable('competitors-table', 'Анализ рынка')"
            >
                Экспорт
                <b-icon
                    v-if="!isExportData"
                    icon="cloud-download"
                    aria-hidden="true"
                ></b-icon>
                <i class="fas fa-spinner fa-spin" v-else></i>
            </b-button>
        </div>
        <div class="d-flex competitors-header" v-if="showHeader && !loading">
            <div class="select-competitors mt-5">
                <b-form-group>
                    <template #label>
                        <b>Выберите компании для построения аналитики:</b><br>
                        <b-form-checkbox
                            v-model="allSelectedCompetitors"
                            aria-describedby="competitorsList"
                            aria-controls="competitorsList"
                            @change="toggleAllCompetitors"
                        >
                            {{ allSelectedCompetitors ? 'Очистить выбранные' : 'Выбрать все' }}
                        </b-form-checkbox>
                    </template>
                
                    <template v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group
                            v-model="selectedCompetitors"
                            id="compatitorsForAnalysis"
                            name="compatitorsForAnalysis"
                            class="ml-4"
                            :options="competitorsList"
                            :aria-describedby="ariaDescribedby"
                            aria-label="Competitors List"
                            value-field="value"
                            text-field="text"                            
                            stacked
                        ></b-form-checkbox-group>
                    </template>
                </b-form-group>
<!--                   
                    <div>
                    Участвуют в анализе: <strong>{{ lineOfNames(selectedCompetitors) }}</strong><br>
                    </div>                     -->
            </div>
            <div class="competitors-settings">
                <div class="d-flex competitors-settings">
                    <b-form-checkbox v-if="showHeader" v-model="noZeroCompetitors" name="check-button" switch>
                        Убрать нулевые
                    </b-form-checkbox>                
                </div>
                <div class="list-of-fields mt-3" v-if="showHeader && !loading">
                    <b-form-group>
                        <template #label>
                            <b title="Чем больше выбрано тем медленнее будет работать">Выберите поля для отображении:</b><br>
                            <b-form-checkbox
                                v-model="allSelectedFieldNames"
                                aria-describedby="fieldsForHeaders"
                                aria-controls="fieldsForHeaders"
                                @change="toggleAllFields"
                            >
                                {{ allSelectedFieldNames ? 'Очистить выбранные' : 'Выбрать все' }}
                            </b-form-checkbox>
                        </template>
                    
                        <template v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group
                                v-model="selectedFieldNames"
                                id="fieldsForHeader"
                                name="fieldsForHeader"
                                class="ml-4"
                                :options="field_names"
                                :aria-describedby="ariaDescribedby"
                                aria-label="Fields List"
                                value-field="value"
                                text-field="text"                            
                                stacked
                            ></b-form-checkbox-group>
                        </template>
                    </b-form-group>

                    <div class="text-center">
                        <b-button 
                            @click="updateSuppliesData()" 
                            size="sm"
                            class="ml-2 text-center"
                            :variant="'outline-primary'"
                            style="height: 35px;"
                        >
                            Применить поля
                            <!-- <b-icon icon="gear-wide" class="ml-2" scale="1.5" aria-label="Settings"></b-icon> -->
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-2">
            <div class="text-right my-2"><small class="text-muted">Всего записей: {{ totalRows }}</small></div>
            <b-table
                id="competitors-table"
                ref="table"
                thead-class="thead-color"
                hover
                :sticky-header="computedWindowHeight"
                :busy="loading"
                :items="filteredSuppliesData['items']"
                :fields="filteredSuppliesData['headers']"
                :current-page="currentPage"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
            >
                <template #table-busy>
                    <div class="text-center text-success my-4">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Загрузка данных...</strong>
                    </div>
                </template>

                <template #cell(name)="row">
                    {{ row.value.first }} {{ row.value.last }}
                </template>

                <template #cell(contacts_recipient_phone)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap">{{ contact.value }}<span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_sender_phone)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap">{{ contact.value }}<span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_declarant_phone)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap">{{ contact.value }}<span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>
        
                <template #cell(contacts_recipient_email)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap">{{ contact.value }}<span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_sender_email)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap">{{ contact.value }}<span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_declarant_email)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap">{{ contact.value }}<span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_recipient_site)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap"><a :href="contact.value" target="_blank">{{ contact.value }}</a><span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_sender_site)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap"><a :href="contact.value" target="_blank">{{ contact.value }}</a><span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>

                <template #cell(contacts_declarant_site)="row">
                    <div v-for="(contact, index) in row.value" :key="index">
                        <div class="no-wrap"><a :href="contact.value" target="_blank">{{ contact.value }}</a><span v-if="contact.name && contact.name != ''" class="small text-muted"> ({{ contact.name }})</span><span v-if="index !== row.value.length - 1">, </span></div>
                    </div>
                </template>
        
                <template #cell(actions)="row">
                    <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                        Info modal
                    </b-button>
                    <b-button size="sm" @click="row.toggleDetails">
                        {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                    </b-button>
                </template>
        
                <template #row-details="row">
                    <b-card>
                        <ul>
                        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                        </ul>
                    </b-card>
                </template>
            </b-table>  
            <b-row>
                <b-col sm="3" md="4" class="my-1">
                    <b-form-group
                        label="На страницу"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="5"
                        label-cols-lg="5"
                        label-align-sm="left"
                        label-size="sm"
                        class="mb-0"
                    >
                        <b-form-select
                            id="per-page-select"
                            style="max-width: 100px; height: 26.5px;"
                            v-model="perPage"
                            :options="pageOptions"
                            size="sm"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            
                <b-col sm="9" md="8" class="my-1">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                    ></b-pagination>
                </b-col>
            </b-row>            
        </div>        
    </div>
</template>

<script>
    import { API_COMPETITORS_SUPPLIES } from '@/constants';
    import { excelExportHelpers } from "../../mixins";

    export default {
        components: {
        },
        mixins: [
            excelExportHelpers,
        ],
        data() {
            return {
                loading: false,
                firstLoad: true,
                analyseData: [],
                competitorsList: [],
                selectedCompetitors: [],
                allSelectedCompetitors: false,
                noZeroCompetitors: true,
                showHeader: false,
                field_names: [],
                selectedFieldNames: [
                                     "ND","G011","G222","G45",
                                     "G474DOL","G33",
                                     "contacts_recipient_email",
                                     "contacts_recipient_phone",
                                     "G141",
                                     "contacts_declarant_email",
                                     "contacts_declarant_phone",
                                     "G081","G082","G0831","G083","G474RUB"
                                    ],
                allSelectedFieldNames: false,
                avaible_periods: null,
                selectedPeriodText: '',
                totalRows: 0,
                currentPage: 1,
                perPage: 100,
                pageOptions: [50, 100, 200, 300, 500, 5000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                computedWindowHeight: '',
            };
        },
        computed: {
            filteredSuppliesData() {
                let filteredData = this.analyseData.filter((_, index) => this.selectedCompetitors.includes(index));
                let items = [];
                let headers = [];

                if (filteredData[0] && filteredData[0].json_data) {
                    items = filteredData.map(obj => obj.json_data.search.result).flat();
                    headers = filteredData[0].json_data.search.headers;
                    headers.sort((a, b) => {
                        const orderA = this.field_names.findIndex(field => field.value === a.key);
                        const orderB = this.field_names.findIndex(field => field.value === b.key);
                        return orderA - orderB;
                    });
                }

                let result = {
                    items: items,
                    headers: headers
                }

                this.totalRows = result.items.length;

                return result;
            },
            sortOptions() {
                return this.filteredSuppliesData
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key }
                })
            }
        },        
        watch: {
            selectedCompetitors(newValue, oldValue) {
                if (newValue.length === 0) {
                    this.allSelectedCompetitors = false
                } else if (newValue.length === this.competitorsList.length) {
                    this.allSelectedCompetitors = true
                } else {
                    this.allSelectedCompetitors = false
                }
            },
            noZeroCompetitors(value) {
                this.onOffnoZeroCompetitors(value);
            }
        },
        mounted() {
            this.handlerHeightWindow()
            this.updateSuppliesData();
        },
        created() {
            window.addEventListener("resize", this.handlerHeightWindow);
        },
        destroyed() {
            window.removeEventListener("resize", this.handlerHeightWindow);
        },
        methods: {
            updateSuppliesData() {
                this.getData();
                if (!this.firstLoad) {
                    this.showHeader = false;
                }
            },
            changePeriod(index) {
                this.getData(index);
            },
            findSelectedPeriod() {
                for(let key in this.avaible_periods) {
                    if (this.avaible_periods[key].selected) {
                        this.selectedPeriodText = `${this.formatDate(this.avaible_periods[key].period_start)} - ${this.formatDate(this.avaible_periods[key].period_finish)}`;
                    }
                }
            },
            getData(period = '') {
                this.loading = true;
                const columns = this.selectedFieldNames.join(",");

                axios.get(`${API_COMPETITORS_SUPPLIES}/?per_page=500&columns=${columns}&period=${period}`).then(({ data }) => {
                    this.analyseData = data.data;
                    this.avaible_periods = data.avaible_periods;
                    this.findSelectedPeriod();
                    this.formListOfFields(data.field_names);
                    this.prepareCompetitorsList();
                    this.loading = false;
                });
            },
            prepareCompetitorsList() {
                this.competitorsList = [];

                this.analyseData.forEach((element, index) => {
                    if (this.noZeroCompetitors) {
                        if (element.json_data.search.found > 0) {
                            this.competitorsList.push({
                                text: `${element.competitor.name} (НЛ: ${element.competitor.license_number}) / ${element.json_data.search.found} поставок`,
                                value: index
                            });
                        }
                    } else {
                        this.competitorsList.push({
                            text: `${element.competitor.name} (НЛ: ${element.competitor.license_number}) / ${element.json_data.search.found} поставок`,
                            value: index
                        });
                    }
                })

                if (this.firstLoad) {
                    this.toggleAllCompetitors(true);
                    this.firstLoad = false;
                }
            },
            formListOfFields(fields) {
                this.field_names = Object.entries(fields)
                                    .sort((a, b) => a[1]["lang"]["RU"].localeCompare(b[1]["lang"]["RU"]))
                                    .map(entry => ({
                                        text: entry[1].lang.RU,
                                        value: entry[0]
                                    }));
            },
            toggleAllCompetitors(checked) {
                this.selectedCompetitors = checked ? this.competitorsList.map(el => el.value) : []
            },
            toggleAllFields(checked) {
                this.selectedFieldNames = checked ? this.field_names.map(el => el.value) : []
            },
            onOffnoZeroCompetitors(checked) {
                this.prepareCompetitorsList();
            },
            lineOfNames(yourList) {
                return yourList.join(', ');
            },
            formatDate(inputDate) {
               return this.$moment(inputDate).format('DD.MM.YYYY');
            },
            handlerHeightWindow() {
                let deleteHeight = 216
                this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
            },  
            moveTableToModal() {
                const table = this.$refs.myTable.$el;
                const modalSlot = this.$refs.modalSlot;
                modalSlot.appendChild(table);
                this.showMaximizedTable = true;
            },
            moveTableBack() {
                const table = this.$refs.myTable.$el;
                const originalPosition = document.querySelector('.mb-2');  // adjust this selector to the container where your table was originally placed
                originalPosition.appendChild(table);
            }                     
        }
    };
</script>

<style scoped>
.fly-competitor-header {
    position: absolute;
    top: 20px;
    right: 21px;
}
.competitors-header {
    justify-content: space-between;
    align-items: flex-start;
}
.select-competitors {
    width: 100%;
    margin-right: 40px;
}
.competitors-settings {
    width: 430px;
    justify-content: flex-end;
    align-items: center;
}
#fieldsForHeader, #compatitorsForAnalysis {
    max-height: 400px;
    overflow: auto;
}
.no-wrap {
    white-space: nowrap;
}
</style>